import * as React from 'react'
import {ReactElement} from 'react'
import {StyledDiv} from '../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Colors} from '../styledComponents/Constants'

export default class FooterAreaComponentAdmin extends React.Component {
    render(): ReactElement {
        return (
            <StyledFooterArea>
                Copyright © HASEKO Corporation. All Rights Reserved.
            </StyledFooterArea>
        )
    }
}

const StyledFooterArea: StyledDiv = styled.div`
  background-color: ${Colors.AdminPrimaryVariant};
  line-height: 1.5;
    text-align: center;
    color: ${Colors.Surface};
  font-size: 12px;
`
